import { Flex, Form, Select, Space, Typography } from 'antd';

import { SearchButtons } from '@app/components';
import { PREFIX } from '@app/constants';
import {
  MONTHS,
  YEARS,
  CURRENT_MONTH,
  CURRENT_YEAR,
} from '@app/pages/Analytics/data';
import { useExpenseByArticlesReport } from '@app/pages/Analytics/ExpenseByArticlesReport/hooks';
import { ExpenseByArticlesReportTable } from '@app/pages/Analytics/ExpenseByArticlesReport/ui/ExpenseByArticlesReportTable';
import { useReportEffects } from '@app/pages/Analytics/hooks';
import '@pages/Analytics/ExpenseByArticlesReport/styles/ExpenseByArticlesReport.desktop.scss';

const { Text } = Typography;
const { Item } = Form;

export const ExpenseByArticlesReport = () => {
  const {
    handleReset,
    form,
    handleSubmitForm,
    tableData,
    handleSearchData,
    isLoading,
  } = useExpenseByArticlesReport();
  useReportEffects({
    handleSearchData,
  });

  return (
    <div className={`${PREFIX}expense-by-articles-report`}>
      <Form
        form={form}
        onFinish={handleSubmitForm}
        initialValues={{
          filterMonth: CURRENT_MONTH.value,
          filterYear: CURRENT_YEAR,
        }}
      >
        <Space
          className="content-header-space"
          direction="vertical"
          size="large"
        >
          <Flex justify="space-between">
            <Space size="large" align="baseline">
              <Text strong>Период:</Text>
              <Item name="filterMonth">
                <Select
                  placeholder="Выбор месяца"
                  popupMatchSelectWidth={false}
                  options={MONTHS}
                  className="filters-select"
                />
              </Item>
              <Item name="filterYear">
                <Select
                  placeholder="Выбор года"
                  popupMatchSelectWidth={false}
                  options={YEARS}
                  className="filters-select"
                />
              </Item>
            </Space>
            <SearchButtons
              className="desktop-buttons"
              resetAll={handleReset}
              showData={form.submit}
            />
          </Flex>

          <ExpenseByArticlesReportTable
            isLoading={isLoading}
            tableData={tableData}
          />
        </Space>
      </Form>
    </div>
  );
};
